import './PageLayout2.scss';
import Sidebar from "../Sidebar/Sidebar";
import TopNavBar from "../TopNavBar/TopNavBar";

export const PageLayout2 = ({ title, children }) => {
    return (
        <div className="layout-container">
            <Sidebar />
            <main className="main-content">
                <TopNavBar title={title} />
                <div className="content">
                    {children}
                </div>
            </main>
        </div>
    );
};
